import { MainImages } from '@lemon/assets';
import { headers } from '../layout/header/Header';

export const Download = () => {
    return (
        <div
            id={headers[5].id}
            className="relative w-full h-[600px] md:h-[700px] flex flex-col items-center justify-center text-white overflow-hidden"
        >
            <img
                src={MainImages.download}
                alt="Download"
                className="w-full h-full object-cover"
                onDragStart={e => e.preventDefault()}
            />

            <div className="absolute inset-0 flex flex-col gap-10 md:gap-20 justify-center items-center bg-black/40">
                <div className="flex flex-col items-center text-[60px] md:text-[120px] font-bold leading-tight">
                    <span>Are you</span>
                    <span>join us?</span>
                </div>
                <a href="http://pf.kakao.com/_xbdxlxin" target="_blank" rel="noopener noreferrer">
                    <button className="w-[200px] h-[50px] md:w-[230px] md:h-[68px] bg-gray-700/80 backdrop-blur-sm text-white font-bold text-lg rounded-[8px] transition-all duration-300 hover:bg-gray-600 hover:scale-105 border border-white/20">
                        크리에이터 신청
                    </button>
                </a>
            </div>
        </div>
    );
};
